// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3dsBU","cell":"ColumnAccessor_cell__dYFjR","firstCellAccent":"ColumnAccessor_firstCellAccent__QuWeG"};